"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePayeeListFailure = exports.updatePayeeListSuccess = exports.updatePayeeList = exports.updatePayeeListAsync = exports.createPayeeListFailure = exports.createPayeeListSuccess = exports.createPayeeList = void 0;
const redux_actions_1 = require("redux-actions");
exports.createPayeeList = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST');
exports.createPayeeListSuccess = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST_SUCCESS');
exports.createPayeeListFailure = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST_FAILURE');
exports.updatePayeeListAsync = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST_ASYNC');
exports.updatePayeeList = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST');
exports.updatePayeeListSuccess = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST_SUCCESS');
exports.updatePayeeListFailure = (0, redux_actions_1.createAction)('UPDATE_PAYEE_LIST_FAILURE');
